export default {
  typeIdentityCard: {
    OLD_ID_CARD: "CHL1",
    NEW_ID_CARD: "CHL2",
    OLD_ID_CARD_GENERIC: "CL_2002_FORMAT",
    NEW_ID_CARD_GENERIC: "CL_2013_FORMAT"
  },
  step: {
    START_SCREEN: "START_SCREEN",
    QR_PAGE: "QR_PAGE",
    ID_CARD_SELECTION: "ID_CARD_SELECTION",
    PHOTO_ID_FRONT: "PHOTO_ID_FRONT",
    PHOTO_ID_BACK: "PHOTO_ID_BACK",
    LIVENESS: "LIVENESS",
    FACIAL_SUCCESS: "FACIAL_SUCCESS",
    FACIAL_ERROR: "FACIAL_ERROR"
  },
  codeError: {
    CAMERA_NOT_AVAILABLE: "CAMERA_NOT_AVAILABLE",
    DETAIL_CAMERA_ERROR: "Camera not available"
  },
  textError: {
    GENERIC_TEXT_ERROR: "No fue posible realizar la validación de identidad",
    DOCUMENT_SCAN_ERROR:
      "No fue posible realizar el scaneo de tu documento, recuerda hacer coincidir tu cédula dentro del recuadro, y espera que el marco aparezca en verde.",
    TOKEN_EXPIRED: "Ha expirado el tiempo para realizar la validación de identidad.",
    CAMERA_NOT_AVAILABLE: "Oops! Hubo un error, no se dieron permisos de cámara en el navegador.",
    BROWSER_NOT_SUPPORTED: "Oops! Hubo un error, el navegador web que estás usando no es compatible."
  },
  resultTypes: {
    success: "SUCCESS",
    expirationError: "EXPIRATION_ERROR",
    rejectedError: "REJECTED_ERROR",
    unknowError: "UNKNOW_ERROR"
  },
  browserVersion: {
    safariMinVersion: 11,
    edgeMinVersion: 79,
    firefoxMinVersion: 92,
    operaMinVersion: 64,
    chromiumMinVersion: 94,
    samsungMinVersion: 4
  },
  tocBrowserErrorCode: "408",
  tocCameraErrorCode: "409",
  source: {
    toc: "TOC",
    fulfillment: "FULFILLMENT_AUTH_WIDGET"
  }
};
